import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "login-container" };
const _hoisted_2 = { class: "login-header" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "login" };
import { ref, onMounted, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useApi, setApiConfig } from '@/composables/useApi';
import { useAppState } from '@/composables/useAppState';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoginPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const api = useApi();
        const state = useAppState();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        // Set API config from route meta (needed for login to work without full useAuth)
        const apiUrl = route.meta.api;
        const configUri = route.meta.configUri;
        state.api = apiUrl;
        state.configUri = configUri;
        setApiConfig({
            api: apiUrl,
            configUri: configUri,
            useCache: state.useCache,
            useCachedEndpoints: state.useCachedEndpoints,
            cachedBlacklist: state.cachedBlacklist,
            cookies: cookies,
            router: router,
        });
        const email = ref('');
        const password = ref('');
        const showPassword = ref(false);
        const colorMode = ref('light');
        const error = ref('');
        function togglePasswordVisibility() {
            showPassword.value = !showPassword.value;
        }
        function login() {
            if (!email.value || !password.value)
                return;
            error.value = '';
            api.login(email.value, password.value, (success) => {
                if (success) {
                    cookies?.set('user', email.value, '1m');
                    cookies?.set('pass', password.value, '1m');
                    const landingPage = route.query.landingpage || '/Wallet';
                    router.replace({ path: landingPage });
                }
                else {
                    error.value = 'Invalid email or password';
                }
            });
        }
        onMounted(() => {
            const savedMode = localStorage.getItem('mg_color_mode');
            if (savedMode) {
                colorMode.value = savedMode;
            }
        });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["login-page", colorMode.value])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("img", {
                            src: require('@/assets/mg.png'),
                            alt: "MG",
                            class: "login-logo"
                        }, null, 8, _hoisted_3),
                        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "login-title" }, "Welcome back", -1)),
                        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "login-subtitle" }, "Sign in to Money Guided", -1))
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Login", -1)),
                        _createVNode(_component_v_text_field, {
                            modelValue: email.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((email).value = $event)),
                            type: "email",
                            "p--repend-inner-icon": "mdi-gbp",
                            "d--ensity": "compact",
                            label: "Email address",
                            variant: "solo",
                            flat: true,
                            "h--ide-details": "",
                            clearable: "",
                            "single-line": "",
                            "bg-color": "white"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_text_field, {
                            modelValue: password.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((password).value = $event)),
                            type: showPassword.value ? 'text' : 'password',
                            "d--ensity": "compact",
                            label: "Password",
                            variant: "solo",
                            flat: true,
                            "h--ide-details": "",
                            clearable: "",
                            "single-line": "",
                            "bg-color": "white",
                            "append-inner-icon": showPassword.value ? 'mdi-eye-off' : 'mdi-eye',
                            "onClick:appendInner": togglePasswordVisibility
                        }, null, 8, ["modelValue", "type", "append-inner-icon"]),
                        _createVNode(MGButton, {
                            text: "Login",
                            stacked: "",
                            onClick: _cache[2] || (_cache[2] = ($event) => (login()))
                        })
                    ])
                ])
            ], 2));
        };
    }
});
